import React from "react";
import { AlertTriangle, Music, Phone, Star, Flame } from "lucide-react";

/**
 * QuickActionButtons - Grid of action buttons for admin panels
 */
export const KaraokeQuickActions = ({ 
  activeSubView, 
  setActiveSubView, 
  pendingCount,
  onSpecialBooking 
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
      <ActionButton
        icon={AlertTriangle}
        label="Pending Payments"
        sublabel="Verify & Confirm"
        isActive={activeSubView === 'pending'}
        onClick={() => setActiveSubView(activeSubView === 'pending' ? null : 'pending')}
        activeColor="red"
        badgeCount={pendingCount}
      />
      
      <ActionButton
        icon={Music}
        label="All Bookings"
        sublabel="View & Manage"
        isActive={activeSubView === 'confirmed'}
        onClick={() => setActiveSubView(activeSubView === 'confirmed' ? null : 'confirmed')}
        activeColor="purple"
      />
      
      <ActionButton
        icon={Phone}
        label="Customer Contacts"
        sublabel="Click-to-Call"
        isActive={activeSubView === 'members'}
        onClick={() => setActiveSubView(activeSubView === 'members' ? null : 'members')}
        activeColor="blue"
      />
      
      <ActionButton
        icon={Star}
        label="Special Booking"
        sublabel="Guest/Partner"
        isActive={activeSubView === 'special'}
        onClick={onSpecialBooking}
        activeColor="amber"
      />
    </div>
  );
};

export const BBQQuickActions = ({ 
  activeSubView, 
  setActiveSubView, 
  pendingCount 
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <ActionButton
        icon={AlertTriangle}
        label="Pending Payments"
        sublabel="Verify & Confirm"
        isActive={activeSubView === 'bbq-pending'}
        onClick={() => setActiveSubView(activeSubView === 'bbq-pending' ? null : 'bbq-pending')}
        activeColor="red"
        badgeCount={pendingCount}
      />
      
      <ActionButton
        icon={Flame}
        label="All BBQ Bookings"
        sublabel="View & Manage"
        isActive={activeSubView === 'bbq-all'}
        onClick={() => setActiveSubView(activeSubView === 'bbq-all' ? null : 'bbq-all')}
        activeColor="orange"
      />
      
      <ActionButton
        icon={Phone}
        label="BBQ Contacts"
        sublabel="Click-to-Call"
        isActive={activeSubView === 'bbq-contacts'}
        onClick={() => setActiveSubView(activeSubView === 'bbq-contacts' ? null : 'bbq-contacts')}
        activeColor="blue"
      />
    </div>
  );
};

/**
 * Generic action button component
 */
const ActionButton = ({ 
  icon: Icon, 
  label, 
  sublabel, 
  isActive, 
  onClick, 
  activeColor = 'blue',
  badgeCount 
}) => {
  const colorClasses = {
    red: { active: 'bg-red-500 text-white', hover: 'hover:bg-red-50' },
    purple: { active: 'bg-purple-500 text-white', hover: 'hover:bg-purple-50' },
    blue: { active: 'bg-blue-500 text-white', hover: 'hover:bg-blue-50' },
    amber: { active: 'bg-amber-500 text-white', hover: 'hover:bg-amber-50' },
    orange: { active: 'bg-orange-500 text-white', hover: 'hover:bg-orange-50' },
    green: { active: 'bg-green-500 text-white', hover: 'hover:bg-green-50' },
  };
  
  const colors = colorClasses[activeColor] || colorClasses.blue;
  
  return (
    <button
      onClick={onClick}
      className={`p-4 border-2 border-black font-bold text-left transition-all relative ${
        isActive ? colors.active : `bg-white ${colors.hover}`
      }`}
    >
      <Icon className="mb-2" size={24} />
      <div className="text-sm">{label}</div>
      <div className="text-xs mt-1">{sublabel}</div>
      {badgeCount > 0 && (
        <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold w-6 h-6 rounded-full flex items-center justify-center">
          {badgeCount}
        </span>
      )}
    </button>
  );
};

export default { KaraokeQuickActions, BBQQuickActions };
